// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Transcript Section */
.transcript-section {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.transcript-section--compact {
  height: 100%;
  overflow: hidden;
}

/* Empty State */
.transcript-empty {
  text-align: center;
  padding: 2rem;
  color: rgb(156, 163, 175);
}

.transcript-empty__message {
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.transcript-empty__note {
  font-size: 0.875rem;
  color: rgb(107, 114, 128);
}

/* Compact View */
.transcript-compact {
  height: 100%;
  overflow-y: auto;
}

.transcript-compact__segments {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.transcript-compact__segment {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;
  min-height: 32px;
}

.transcript-compact__segment:hover {
  background-color: rgba(55, 65, 81, 0.3);
}

.transcript-compact__timestamp {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  background-color: rgba(37, 99, 235, 0.2);
  color: rgb(96, 165, 250);
  border: 1px solid rgba(96, 165, 250, 0.3);
  border-radius: 0.25rem;
  flex-shrink: 0;
  height: 22px;
  min-width: 55px;
  width: 55px;
  font-family: 'Courier New', monospace;
}

.transcript-compact__text {
  color: rgb(209, 213, 219);
  font-size: 0.875rem;
  line-height: 1.625;
  flex: 1 1;
  margin: 0;
  display: flex;
  align-items: center;
  min-height: 22px;
}

/* Full View */
.transcript-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.transcript-header__title {
  font-size: 1.25rem;
  font-weight: 600;
  color: white;
}

/* Search */
.transcript-search {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.transcript-search__input {
  background-color: rgba(31, 41, 55, 0.5);
  border: 1px solid rgb(55, 65, 81);
  border-radius: 0.375rem;
  padding: 0.5rem 1rem;
  color: white;
  font-size: 0.875rem;
  width: 250px;
}

.transcript-search__input:focus {
  outline: none;
  border-color: rgb(96, 165, 250);
  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);
}

.transcript-search__input::placeholder {
  color: rgb(156, 163, 175);
}

.transcript-search__results {
  color: rgb(156, 163, 175);
  font-size: 0.875rem;
}

/* Content */
.transcript-content {
  flex: 1 1;
  overflow-y: auto;
  padding-right: 0.5rem;
}

/* No Results */
.transcript-no-results {
  text-align: center;
  padding: 2rem;
}

.transcript-no-results__message {
  color: rgb(156, 163, 175);
  font-size: 1rem;
}

/* Segments */
.transcript-segments {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.transcript-segment {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.transcript-segment__timestamp {
  background: none;
  border: 1px solid rgba(96, 165, 250, 0.3);
  color: rgb(96, 165, 250);
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Courier New', monospace;
  white-space: nowrap;
}

.transcript-segment__timestamp:hover {
  background-color: rgba(37, 99, 235, 0.1);
  border-color: rgb(96, 165, 250);
}

.transcript-segment__text {
  color: rgb(209, 213, 219);
  font-size: 0.875rem;
  line-height: 1.625;
  flex: 1 1;
}

/* Footer */
.transcript-footer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgb(55, 65, 81);
}

.transcript-footer__info {
  color: rgb(156, 163, 175);
  font-size: 0.75rem;
}

/* Code Blocks */
.code-block {
  background-color: rgba(31, 41, 55, 0.5);
  border: 1px solid rgb(55, 65, 81);
  border-radius: 0.375rem;
  padding: 1rem;
  margin: 0.5rem 0;
  font-family: 'Courier New', monospace;
  font-size: 0.875rem;
  line-height: 1.5;
  overflow-x: auto;
  position: relative;
}

.code-block::before {
  content: attr(class);
  content: attr(class);
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  color: rgb(156, 163, 175);
  background-color: rgba(31, 41, 55, 0.8);
  border-bottom-left-radius: 0.375rem;
  text-transform: uppercase;
}

.code-block code {
  color: rgb(209, 213, 219);
}

/* Search Highlighting */
mark {
  background-color: rgba(37, 99, 235, 0.2);
  color: rgb(96, 165, 250);
  padding: 0.125rem 0.25rem;
  border-radius: 0.125rem;
}

/* Scrollbar */
.transcript-content::-webkit-scrollbar,
.transcript-compact::-webkit-scrollbar {
  width: 6px;
}

.transcript-content::-webkit-scrollbar-track,
.transcript-compact::-webkit-scrollbar-track {
  background: rgba(55, 65, 81, 0.3);
  border-radius: 3px;
}

.transcript-content::-webkit-scrollbar-thumb,
.transcript-compact::-webkit-scrollbar-thumb {
  background: rgba(107, 114, 128, 0.5);
  border-radius: 3px;
}

.transcript-content::-webkit-scrollbar-thumb:hover,
.transcript-compact::-webkit-scrollbar-thumb:hover {
  background: rgba(107, 114, 128, 0.7);
}

/* Responsive */
@media (max-width: 640px) {
  .transcript-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .transcript-search {
    width: 100%;
  }

  .transcript-search__input {
    width: 100%;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/VideoTabs/TranscriptTab.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,wBAAwB;EACxB,yCAAyC;EACzC,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAO;EACP,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAO;AACT;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,uCAAuC;EACvC,iCAAiC;EACjC,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;EACvC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,wCAAwC;EACxC,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,cAAc;AACd;;EAEE,UAAU;AACZ;;AAEA;;EAEE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Transcript Section */\n.transcript-section {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.transcript-section--compact {\n  height: 100%;\n  overflow: hidden;\n}\n\n/* Empty State */\n.transcript-empty {\n  text-align: center;\n  padding: 2rem;\n  color: rgb(156, 163, 175);\n}\n\n.transcript-empty__message {\n  font-size: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.transcript-empty__note {\n  font-size: 0.875rem;\n  color: rgb(107, 114, 128);\n}\n\n/* Compact View */\n.transcript-compact {\n  height: 100%;\n  overflow-y: auto;\n}\n\n.transcript-compact__segments {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.transcript-compact__segment {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  min-height: 32px;\n}\n\n.transcript-compact__segment:hover {\n  background-color: rgba(55, 65, 81, 0.3);\n}\n\n.transcript-compact__timestamp {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  background-color: rgba(37, 99, 235, 0.2);\n  color: rgb(96, 165, 250);\n  border: 1px solid rgba(96, 165, 250, 0.3);\n  border-radius: 0.25rem;\n  flex-shrink: 0;\n  height: 22px;\n  min-width: 55px;\n  width: 55px;\n  font-family: 'Courier New', monospace;\n}\n\n.transcript-compact__text {\n  color: rgb(209, 213, 219);\n  font-size: 0.875rem;\n  line-height: 1.625;\n  flex: 1;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  min-height: 22px;\n}\n\n/* Full View */\n.transcript-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.transcript-header__title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: white;\n}\n\n/* Search */\n.transcript-search {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.transcript-search__input {\n  background-color: rgba(31, 41, 55, 0.5);\n  border: 1px solid rgb(55, 65, 81);\n  border-radius: 0.375rem;\n  padding: 0.5rem 1rem;\n  color: white;\n  font-size: 0.875rem;\n  width: 250px;\n}\n\n.transcript-search__input:focus {\n  outline: none;\n  border-color: rgb(96, 165, 250);\n  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.2);\n}\n\n.transcript-search__input::placeholder {\n  color: rgb(156, 163, 175);\n}\n\n.transcript-search__results {\n  color: rgb(156, 163, 175);\n  font-size: 0.875rem;\n}\n\n/* Content */\n.transcript-content {\n  flex: 1;\n  overflow-y: auto;\n  padding-right: 0.5rem;\n}\n\n/* No Results */\n.transcript-no-results {\n  text-align: center;\n  padding: 2rem;\n}\n\n.transcript-no-results__message {\n  color: rgb(156, 163, 175);\n  font-size: 1rem;\n}\n\n/* Segments */\n.transcript-segments {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.transcript-segment {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.transcript-segment__timestamp {\n  background: none;\n  border: 1px solid rgba(96, 165, 250, 0.3);\n  color: rgb(96, 165, 250);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-family: 'Courier New', monospace;\n  white-space: nowrap;\n}\n\n.transcript-segment__timestamp:hover {\n  background-color: rgba(37, 99, 235, 0.1);\n  border-color: rgb(96, 165, 250);\n}\n\n.transcript-segment__text {\n  color: rgb(209, 213, 219);\n  font-size: 0.875rem;\n  line-height: 1.625;\n  flex: 1;\n}\n\n/* Footer */\n.transcript-footer {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgb(55, 65, 81);\n}\n\n.transcript-footer__info {\n  color: rgb(156, 163, 175);\n  font-size: 0.75rem;\n}\n\n/* Code Blocks */\n.code-block {\n  background-color: rgba(31, 41, 55, 0.5);\n  border: 1px solid rgb(55, 65, 81);\n  border-radius: 0.375rem;\n  padding: 1rem;\n  margin: 0.5rem 0;\n  font-family: 'Courier New', monospace;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  overflow-x: auto;\n  position: relative;\n}\n\n.code-block::before {\n  content: attr(class);\n  content: attr(class);\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  color: rgb(156, 163, 175);\n  background-color: rgba(31, 41, 55, 0.8);\n  border-bottom-left-radius: 0.375rem;\n  text-transform: uppercase;\n}\n\n.code-block code {\n  color: rgb(209, 213, 219);\n}\n\n/* Search Highlighting */\nmark {\n  background-color: rgba(37, 99, 235, 0.2);\n  color: rgb(96, 165, 250);\n  padding: 0.125rem 0.25rem;\n  border-radius: 0.125rem;\n}\n\n/* Scrollbar */\n.transcript-content::-webkit-scrollbar,\n.transcript-compact::-webkit-scrollbar {\n  width: 6px;\n}\n\n.transcript-content::-webkit-scrollbar-track,\n.transcript-compact::-webkit-scrollbar-track {\n  background: rgba(55, 65, 81, 0.3);\n  border-radius: 3px;\n}\n\n.transcript-content::-webkit-scrollbar-thumb,\n.transcript-compact::-webkit-scrollbar-thumb {\n  background: rgba(107, 114, 128, 0.5);\n  border-radius: 3px;\n}\n\n.transcript-content::-webkit-scrollbar-thumb:hover,\n.transcript-compact::-webkit-scrollbar-thumb:hover {\n  background: rgba(107, 114, 128, 0.7);\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .transcript-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .transcript-search {\n    width: 100%;\n  }\n\n  .transcript-search__input {\n    width: 100%;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
